import type { Receipt } from '../../../services/financial/types';
import { downloadBlob } from '../../../shared/utils/download-blob.util';
import { formatCurrency, formatDateToBrazil } from '../../../shared/utils';

const STATUS_LABEL: Record<Receipt['status'], string> = {
  paid: 'Pago',
  pending: 'Pendente',
};

/** Escapa um campo para CSV (separador `;`, padrão pt-BR do Excel). */
const cell = (value: string) => `"${value.replace(/"/g, '""')}"`;

const stampToday = (): string => {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  return `${now.getFullYear()}-${mm}-${dd}`;
};

/**
 * Exporta a lista de recibos (já filtrada/consultada na API) para CSV no layout
 * da story 978: Favorecido (só Seguradora), Recibo, Valor Líquido, Previsão de
 * Pagamento, Data de Pagamento, Status. Abre no Excel (BOM UTF-8 + separador `;`,
 * padrão pt-BR).
 */
export function downloadReceiptsListCsv(
  receipts: Receipt[],
  options: { includeBeneficiary: boolean }
): void {
  const { includeBeneficiary } = options;

  const header = [
    ...(includeBeneficiary ? ['Favorecido'] : []),
    'Recibo',
    'Valor Líquido',
    'Previsão de Pagamento',
    'Data de Pagamento',
    'Status',
  ];

  const rows = receipts.map(receipt => [
    ...(includeBeneficiary ? [receipt.favorecidoName ?? ''] : []),
    String(receipt.receiptNumber),
    formatCurrency(receipt.netValue),
    receipt.paymentForecast ? formatDateToBrazil(receipt.paymentForecast) : '',
    receipt.paymentDate ? formatDateToBrazil(receipt.paymentDate) : '',
    STATUS_LABEL[receipt.status],
  ]);

  const csv =
    '﻿' + [header, ...rows].map(cols => cols.map(cell).join(';')).join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  downloadBlob(blob, `recibos-${stampToday()}.csv`);
}
